// PageDescription: 커뮤니티 리스트 페이지
import { QueryClient, dehydrate } from '@tanstack/react-query';
import { GetServerSideProps } from 'next';
import { NextSeo } from 'next-seo';
import React from 'react';

import DefaultLayout from '@/components/layouts/DefaultLayout';
import CommunityListTemplate from '@/components/templates/mobile/communication/Community/CommunityListTemplate';
import { useGetNewestBoardPostCursorPageQuery } from '@/hooks/community/mobile/community.gql.impl';
import { CustomPageProps } from '@/types/app';
import { ROUTES } from '@/types/common';

const CommunityListPage = ({ client }: CustomPageProps) => {
  return (
    <>
      <NextSeo
        title="커뮤니티 - 닥터나우"
        canonical={`${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.COMMUNITY.LIST.path}`}
        description="피부, 탈모, 육아 등 다양한 카테고리에서 나와 비슷한 고민을 가진 사람들을 만나보세요."
        openGraph={{
          url: `${process.env.NEXT_PUBLIC_DOMAIN}${ROUTES.COMMUNITY.LIST.path}`,
          title: '커뮤니티 - 닥터나우',
          description:
            '피부, 탈모, 육아 등 다양한 카테고리에서 나와 비슷한 고민을 가진 사람들을 만나보세요.',
          images: [
            {
              url: `${process.env.NEXT_PUBLIC_COMMUNITY_OG_IMAGE}`,
              alt: 'Og Image Alt',
            },
          ],
        }}
        twitter={{
          handle: '@doctornow',
          site: '@doctornow.co.kr',
          cardType: 'summary_large_image',
        }}
      />
      <CommunityListTemplate client={client} />
    </>
  );
};

CommunityListPage.Layout = DefaultLayout;

export default CommunityListPage;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const queryClient = new QueryClient();
  const query = ctx.query.categoryId as string | null;

  await queryClient.prefetchInfiniteQuery(
    useGetNewestBoardPostCursorPageQuery.getKey({
      request: {
        size: 20,
        boardCategoryId: query,
      },
    }),
    useGetNewestBoardPostCursorPageQuery.fetcher({
      request: {
        size: 20,
        boardCategoryId: query,
      },
    }),
  );

  return {
    props: {
      dehydratedState: JSON.parse(JSON.stringify(dehydrate(queryClient))),
    },
  };
};
